export default __webpack_public_path__ + "assets/images/icons/github.f0b8504a.svg";